import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config';

// The single place a login response is turned into a session.
//
// Password login and Microsoft sign-in both come through here. These writes
// used to live inside the login page, which meant the Microsoft path had to
// reproduce every one of them, and any key added to one would be silently
// missing from the other - leaving SSO users without a module flag for no
// visible reason.

const persistSession = (data, history, layoutURL) => {
    localStorage.setItem("login", true);
    localStorage.setItem("sessiontoken", data.token);
    localStorage.setItem("usertype", data.user_role);
    localStorage.setItem("usertypeId", data.user_type_id);
    localStorage.setItem("concessionaireId", data.user_concessionaire_id);
    localStorage.setItem("concessionaireName", data.user_concessionaire_name);
    localStorage.setItem("loginId", data.user_id);
    localStorage.setItem("loginName", data.first_name);
    localStorage.setItem("tenantId", data.user_tenant_id);
    localStorage.setItem("propertyAccess", data.property_id);
    localStorage.setItem("dataMode", data.data_mode);
    localStorage.setItem("auditRequired", data.audit_required ? "true" : "false");
    localStorage.setItem("auditTolerance", data.audit_tolerance ?? "0");
    localStorage.setItem("auditIndividualTenants", data.audit_individual_tenants ? "true" : "false");

    const userTypeId = data.user_type_id;
    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    if (data.user_role === "admin") { //admin
        localStorage.setItem("accessDashboard", "1")
        localStorage.setItem("accessAnalytics", "1")
        localStorage.setItem("accessReports", "1")
        localStorage.setItem("accessRevenueReports", "1")
        localStorage.setItem("accessDataGrid", "1")
        localStorage.setItem("accessGeneralSettings", "1")
        localStorage.setItem("manageGeneralSettings", "1")
        localStorage.setItem("accessTenants", "1")
        localStorage.setItem("manageTenants", "1")
        localStorage.setItem("manageConfigurations", "1")
        localStorage.setItem("manageUsers", "1")
        localStorage.setItem("manageUserProfile", "1")
        localStorage.setItem("accessLogs", "1")
        localStorage.setItem("manageScheduleReports", "1")
        localStorage.setItem("tenantPortalManage", "1")
        localStorage.setItem("manageLeaseDetails", "1")
        localStorage.setItem("accessLicenses", "1")
        localStorage.setItem("manageLicenses", "1")
        localStorage.setItem("bulkDataUpload", "1")
        localStorage.setItem("accessAudit", "1")
        history(`${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`); //admin
    }
    else if (data.user_role === "sadmin") {
        history(`${process.env.PUBLIC_URL}/controlpanel/dashboard/default/${layoutURL}`)   //super admin
    }
    else if (data.user_role === "tenant") {
        history(`${process.env.PUBLIC_URL}/tenant/home/${layoutURL}`)  //Tenant
    }
    else if (data.user_role === "Backend User") {
        localStorage.setItem("dataDeletePermission", data.data_delete_permission)
        localStorage.setItem("accessLicenses", "1")
        localStorage.setItem("manageLicenses", "1")
        localStorage.setItem("bulkDataUpload", "1")
        localStorage.setItem("accessAudit", "1")
        history(`${process.env.PUBLIC_URL}/admin/home/${layoutURL}`)  //Backend Users
    }
    else {
        axios.post(`${config.hostname}/userpermissions/getpermissionbyusertype`, { user_type_id: userTypeId }, configheader)
            .then((response) => {
                localStorage.setItem("accessDashboard", response.data[0].access_dashboard)
                localStorage.setItem("accessAnalytics", response.data[0].access_analytics)
                localStorage.setItem("accessReports", response.data[0].access_report)
                localStorage.setItem("accessRevenueReports", response.data[0].revenue_share_reports)
                localStorage.setItem("accessDataGrid", response.data[0].access_data_grid)
                localStorage.setItem("accessGeneralSettings", response.data[0].acess_general_settings)
                localStorage.setItem("manageGeneralSettings", response.data[0].manage_general_settings)
                localStorage.setItem("accessTenants", response.data[0].access_tenants)
                localStorage.setItem("manageTenants", response.data[0].manage_tenants)
                localStorage.setItem("manageConfigurations", response.data[0].manage_configurations)
                localStorage.setItem("manageUsers", response.data[0].manage_users)
                localStorage.setItem("manageUserProfile", response.data[0].manage_user_profile)
                localStorage.setItem("accessLogs", response.data[0].access_logs)
                localStorage.setItem("manageScheduleReports", response.data[0].manage_schedule_reports)
                localStorage.setItem("tenantPortalManage", response.data[0].manual_portal_access)
                localStorage.setItem("manageLeaseDetails", response.data[0].manage_lease_details)
                localStorage.setItem("accessLicenses", response.data[0].access_licenses || 0)
                localStorage.setItem("manageLicenses", response.data[0].manage_licenses || 0)
                localStorage.setItem("bulkDataUpload", response.data[0].bulk_data_upload || 0)
                localStorage.setItem("accessAudit", response.data[0].access_audit || 0)

                history(`${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`);    //admin users
            })
            .catch((error) => {
                console.log(error);
                toast.error("error on fetching permissions");
            });
    }
};

export default persistSession;
